<template>
  <v-card :outlined="$vuetify.breakpoint.mdAndUp"
          :tile="$vuetify.breakpoint.smAndDown"
          class="fill-height scheduled-projects-card">
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-card-title>
        {{ productionLine.name || $t('production_timeline.production_line') }}
        <v-spacer/>
        <v-btn v-if="isAdmin" icon small @click="$emit('refresh')">
          <v-icon>mdi mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider/>
    </template>
    <v-card-text class="queue-scroll pa-0">
      <v-fade-transition hide-on-leave>
        <v-row v-if="loading" class="pa-2">
          <v-col cols="12">
            <project-card-skeleton-loader v-for="i in [1, 2, 3]" :key="i"/>
          </v-col>
        </v-row>
      </v-fade-transition>

      <v-fade-transition hide-on-leave>
        <div v-if="!loading && weeks.length > 0"
             class="production-timeline-queue-scroll"
             style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; overflow-y: auto;">
          <v-row no-gutters>
            <v-col style="z-index: 2;">
              <production-line-week
                v-for="week in weeks"
                :key="week.weekNumber"
                :is-admin="isAdmin"
                :line-has-projects="lineHasProjects"
                :updating="updating"
                :week="week"
                :production-lines="productionLines"
                @drag-change="(e) => $emit('drag-change', { event: e, weekNumber: week.weekNumber, productionLineId: productionLine.id })"
                @assign-to-line="(e) => $emit('assign-to-line', e)"
                @unschedule="(e) => $emit('unschedule', e)"/>
            </v-col>
          </v-row>
        </div>
      </v-fade-transition>

      <v-fade-transition hide-on-leave>
        <no-content-view
          v-if="!loading && weeks.length === 0"
          :class="$vuetify.breakpoint.smAndUp ? 'pt-10' : ''"
          :description="$t('production_timeline.no_scheduled_projects_description')"
          :reload-button="false"
          :title="$t('production_timeline.no_scheduled_projects')"
          dense
          title-icon="mdi mdi-calendar-blank"/>
      </v-fade-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import ProductionLineWeek from './ProductionLineWeek';
import ProjectCardSkeletonLoader from './ProjectCardSkeletonLoader';
import NoContentView from '@/components/NoContentView';

export default {
  name: 'ProductionLineColumn',
  components: { ProductionLineWeek, ProjectCardSkeletonLoader, NoContentView },
  computed: {
    lineHasProjects() {
      return this.weeks.some(w => w.projects.length > 0);
    }
  },
  props: {
    productionLine: {
      type: Object,
      required: true
    },
    weeks: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    updating: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    productionLines: {
      type: Array,
      default: () => []
    }
  }
};
</script>
